export default __webpack_public_path__ + "static/media/PickupImage_123.14f61d75.jpg";